module.exports = __webpack_public_path__ + "img/unique@2x.8547c4a.jpg";